import _, { set } from 'lodash';
import { defaultLocale } from 'i18n';
import dayjs from 'dayjs';
import i18n from 'i18next';
import Cookies from 'universal-cookie';
import BaseService from "services/base/base.service";


export const LANGUAGES = ['en', 'it'];
export const DEFAULT_LANG = 'en';
export const STRATEGIES_LIBRARY_PATH = '/strategies-library';

const cookies = new Cookies();

export const performLanguageChange = async ({ lang, isAuth, location, navigate, onStart, onFinish }) => {
    if (lang === i18n.language) return;
    if (onStart) onStart();

    try {

        if (isAuth && lang) await BaseService.post('/lang', { lang });
        saveLanguageLocally(lang);

        // reload page
        const currentPath = window.location.pathname;
        let finalUrl = getLanguagePath(lang, currentPath);

        if (currentPath.includes('/check_two_factor')) {
            // Для 2FA принудительно обновляем
            let baseUrl = getLanguagePath(lang, currentPath);
            if (location?.state?.data) {
                const data = JSON.stringify(location.state.data);
                const dataRes = encodeURI(data.split('').map(c => c.charCodeAt(0)).join('|'));
                finalUrl = baseUrl + '?data=' + dataRes;
            } else {
                finalUrl = baseUrl + window.location.search;
            }
        } else {
            // Для остальных страниц
            finalUrl = finalUrl + window.location.search;
        }
        setTimeout(() => {
            window.location.href = finalUrl;
        }, 200)
    } catch (error) {
        console.error(error);
    } finally {
        if (onFinish) onFinish();
    }
};

export const saveLanguageLocally = (lang) => {
    const maxAgeInSeconds = 400 * 24 * 60 * 60; // 400 дней

    // 1. Установка куки
    cookies.set('lang', lang, {
        path: '/',
        maxAge: maxAgeInSeconds,
        // sameSite: 'lax'
    });

    // 2. Смена языка в i18n
    if (i18n.language !== lang) {
        i18n.changeLanguage(lang);
    }
};

export const detectLanguage = () => {
    if (typeof window === 'undefined') return defaultLocale;
    const pathLang = getLocaleFromPath(window.location.pathname);
    return LANGUAGES.includes(pathLang) ? pathLang : defaultLocale;
};

export const getLanguagePath = (targetLang, currentPath = window.location.pathname) => {
    const parts = currentPath.split('/').filter(Boolean);

    // Проверяем, является ли первый сегмент известным языком
    if (LANGUAGES.includes(parts[0])) {
        parts.shift();
    }

    const cleanPath = parts.join('/');

    if (targetLang === DEFAULT_LANG) {
        return cleanPath ? `/${cleanPath}` : '/'; // возвращаем / для главной
    }

    // Для других языков: если cleanPath пустой, не добавляем лишний слеш в конце
    return cleanPath ? `/${targetLang}/${cleanPath}` : `/${targetLang}`;
};

export function prefixPath(path, prefix) {
    //return `/${_.trim(prefix, '/')}/${_.trim(path, '/')}`;
    return `/${_.trim(path, '/')}`
}

export function getLocalePrefix() {
    return i18n.language === 'en' ? '' : '/' + i18n.language;
}
export function getLocaleLink(link) {
    if (i18n.language === 'en') return link;
    const normalizedLink = link.startsWith('/') ? link.slice(1) : link;
    return `/${i18n.language}/${normalizedLink}`;
}

export function getLocaleFromPath(path) {
    if (path === "/") {
        return defaultLocale
    }
    return path.split('/')[1]
}

export function getFormattedDuration(total_seconds) {
    let hours = Math.floor(total_seconds / 3600)
    let minutes = Math.floor((total_seconds - (hours * 3600)) / 60)
    if (total_seconds < 60) minutes = 1
    return (hours === 0 && minutes === 0) ? ' - ' : ((hours === 0) ? "" : hours + " h ") + ((minutes === 0) ? "" : minutes + " min")
}


export function getFormattedDate(date = false) {
    if (date) {
        return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
    }
    return dayjs().format('YYYY-MM-DD HH:mm:ss') // display
}

export const convert = (value) => {
    value = parseInt(value) || 0;
    if (value >= 1000000) {
        return value = Math.round(value / 1000000) + 'M'
    }
    if (value >= 1000) {
        return value = Math.round(value / 1000) + 'k'
    }
    return value
}

export const baseRouteUrl = ''

export const prepareUrl = (path) => {
    return '/' + defaultLocale + '/' + path
}
